import { render, staticRenderFns } from "./reminderModel.vue?vue&type=template&id=00702424"
import script from "./reminderModel.vue?vue&type=script&lang=js"
export * from "./reminderModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00702424')) {
      api.createRecord('00702424', component.options)
    } else {
      api.reload('00702424', component.options)
    }
    module.hot.accept("./reminderModel.vue?vue&type=template&id=00702424", function () {
      api.rerender('00702424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/reminderManage/reminderModel.vue"
export default component.exports